import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAspectRatio219: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconAspectRatio219"><Path d="M0.75 9.75C0.75 8.09315 2.09315 6.75 3.75 6.75H20.25C21.9069 6.75 23.25 8.09315 23.25 9.75V14.25C23.25 15.9069 21.9069 17.25 20.25 17.25H3.75C2.09315 17.25 0.75 15.9069 0.75 14.25V9.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconAspectRatio219;
